import React from 'react'
import { QueryClient, QueryClientProvider as TanstackQueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { DEFAULT_RETRY_COUNT } from '../config'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: DEFAULT_RETRY_COUNT,
      retryDelay: (attemptIndex, error) => {
        // eslint-disable-next-line no-console -- We want to log this
        attemptIndex > 0 && console.log(`[React Query] Retrying request (attempt ${attemptIndex + 1})`, { error })
        return Math.min(1000 * 2 ** attemptIndex, 30000) // exponential backoff
      },
      staleTime: Infinity, // If we had stale data, we should trigger it programmatically instead of relying on some sort of timeout
    },
  },
})

export const QueryClientProvider = ({ children }: { children: React.ReactNode }): JSX.Element => (
  <TanstackQueryClientProvider client={queryClient}>
    {children}
    {process.env.NODE_ENV === 'development' && <ReactQueryDevtools initialIsOpen={false} />}
  </TanstackQueryClientProvider>
)
